import { MessageCircle, Phone } from "lucide-react";
import { SITE, waLink, WA_MESSAGES } from "@/config/site";

// Sticky mobile bottom bar. The Call button stays disabled until a separate
// telephone number is confirmed (SITE.callHotlineNumber).
const StickyMobileBar = () => (
  <div
    data-testid="sticky-mobile-bar"
    className="fixed bottom-0 inset-x-0 z-50 md:hidden grid grid-cols-2 border-t border-white/20 shadow-[0_-8px_30px_rgb(0,0,0,0.12)]"
    style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
  >
    <a
      href={waLink(WA_MESSAGES.homepage)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="sticky-whatsapp-btn"
      className="flex flex-col items-center justify-center gap-0.5 bg-brand-teal px-2 py-3 text-white active:bg-brand-teal/90"
    >
      <span className="flex items-center gap-1.5 text-sm font-semibold">
        <MessageCircle className="h-4 w-4" /> WhatsApp Consultation
      </span>
      <span className="text-[10px] text-white/70">Free care-matching assistance</span>
    </a>
    {SITE.callHotlineNumber ? (
      <a
        href={SITE.callHotlineUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sticky-call-btn"
        className="flex flex-col items-center justify-center gap-0.5 bg-brand-gold px-2 py-3 text-white active:bg-brand-gold/90"
      >
        <span className="flex items-center gap-1.5 text-sm font-semibold">
          <Phone className="h-4 w-4" /> Call Advisory Hotline
        </span>
        <span className="text-[10px] text-white/80">WhatsApp call to {SITE.whatsappDisplay}</span>
      </a>
    ) : (
      <button
        type="button"
        data-testid="sticky-call-btn"
        disabled
        aria-disabled="true"
        title="Call Advisory Hotline will be activated once the telephone number is confirmed. Please use WhatsApp for now."
        className="flex flex-col items-center justify-center gap-0.5 bg-slate-200 px-2 py-3 text-slate-400 cursor-not-allowed"
      >
        <span className="flex items-center gap-1.5 text-sm font-semibold">
          <Phone className="h-4 w-4" /> Call Advisory Hotline
        </span>
        <span className="text-[10px] opacity-80">Number to be confirmed</span>
      </button>
    )}
  </div>
);

export default StickyMobileBar;
